class PickupAvailability extends HTMLElement {
  constructor() {
    super();

    if (!this.hasAttribute('available')) return;

    this.variantAvailabilitiesCache = new Map();
    this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
    this.onClickRefreshList = this.onClickRefreshList.bind(this);
    this.onClickAvailabilityTrigger = this.onClickAvailabilityTrigger.bind(this);
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const rootUrl = !this.dataset.rootUrl.endsWith('/') ? `${this.dataset.rootUrl}/` : this.dataset.rootUrl;
    const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

    fetch(variantSectionUrl)
      .then(response => response.text())
      .then(text => {
        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');
        this.renderPreview(sectionInnerHTML);
      })
      .catch(e => {
        const button = this.querySelector('button');

        if (button)
          button.removeEventListener(
            'click',
            this.onClickRefreshList
          );

        this.renderError();
      });
  }

  onClickRefreshList(event) {
    this.fetchAvailability(this.dataset.variantId);
  }

  async onClickAvailabilityTrigger() {
    const variantId = this.getCurrentVariantId();
    if (!variantId) return;

    this.dataset.variantId = variantId;
    await this.fetchVariantAvailabilities(variantId);
  }

  getCurrentVariantId() {
    const productInfo = this.closest('product-info');
    const variantInput = productInfo?.querySelector('product-form form [name="id"]');

    return variantInput?.value || this.dataset.variantId;
  }

  getAvailabilitiesEndpoint() {
    return (
      this.querySelector('#Pickup-Availability-drawer')?.dataset.pickupAvailabilityEndpoint || 'https://api.contescarpemoda.it/variants/availabilities'
    );
  }

  async fetchVariantAvailabilities(variantId) {
    const cacheKey = String(variantId);
    const trigger = this.querySelector('[data-pickup-availability-trigger]');

    if (this.variantAvailabilitiesCache.has(cacheKey)) {
      this.renderVariantAvailabilities(this.variantAvailabilitiesCache.get(cacheKey));
      return;
    }

    try {
      trigger?.setAttribute('aria-busy', 'true');

      const response = await fetch(this.getAvailabilitiesEndpoint(), {
        method: 'POST',
        headers: {Accept: 'application/json','Content-Type': 'application/json'},
        body: JSON.stringify({ variantId: cacheKey })
      });

      if (!response.ok) {
        throw new Error(`Unable to fetch pickup availabilities for variant ${cacheKey}`);
      }

      const payload = await response.json();
      this.variantAvailabilitiesCache.set(cacheKey, payload);
      this.renderVariantAvailabilities(payload);
    } catch (error) {
      console.error(error);
    } finally {
      trigger?.removeAttribute('aria-busy');
    }
  }

  renderVariantAvailabilities(payload) {
    const availabilities = Array.isArray(payload?.availabilities) ? payload.availabilities : [];

    availabilities.forEach(availability => {
      const locationEl = this.getLocationElement(availability?.locationId);

      if (!locationEl) return;

      const stockEl = locationEl.querySelector('[data-pickup-stock]');
      if (!stockEl) return;

      const quantity = Number(availability?.available);
      const normalizedQuantity = Number.isFinite(quantity) ? quantity : 0;

      locationEl.hidden = normalizedQuantity <= 0;
      // stockEl.textContent = `Giacenza: ${normalizedQuantity}`;
      // stockEl.hidden = false;
    });
  }

  getLocationElement(locationId) {
    const normalizedLocationId = this.normalizeShopifyResourceId(locationId);

    return Array.from(
      this.querySelectorAll('[data-pickup-location-id]')
    ).find(
      locationEl =>
        this.normalizeShopifyResourceId(locationEl.dataset.pickupLocationId) === normalizedLocationId
    );
  }

  normalizeShopifyResourceId(id) {
    return String(id || '').split('/').pop();
  }

  bindAvailabilityTrigger() {
    const trigger = this.querySelector('[data-pickup-availability-trigger]');

    if (!trigger) return;

    trigger.removeEventListener('click',this.onClickAvailabilityTrigger);
    trigger.addEventListener('click',this.onClickAvailabilityTrigger);
  }

  renderError() {
    this.innerHTML = '';
    this.appendChild(this.errorHtml);
    this.querySelector('button').addEventListener('click',this.onClickRefreshList);
  }

  renderPreview(sectionInnerHTML) {
    if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
      this.innerHTML = '';
      this.removeAttribute('available');
      return;
    }
    this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
    this.setAttribute('available', '');
    this.bindAvailabilityTrigger();
  }
}

customElements.define('pickup-availability', PickupAvailability);
